/* MotoWing "Sana Özel Ürünler" rafı — bkz. sections/mw-foryou.liquid */
(function(){
  var box=document.querySelector('[data-mwr-fy]');
  if(!box||!window.fetch||!window.Promise||!window.DOMParser) return;
  var list=box.querySelector('[data-mwr-fy-list]'), sen=document.querySelector('[data-mwr-fy-s]');
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/', done=false;
  function rd(k,d){ try{ var v=JSON.parse(localStorage.getItem(k)); return v==null?d:v; }catch(e){ return d; } }
  function ok(r){ return r&&r.ok; }
  function go(){
    if(done) return; done=true;
    var rv=rd('mw_rv',[]); if(!Array.isArray(rv)) rv=[];
    var ids=rd('mw_rvid',{}); if(!ids||typeof ids!=='object') ids={};
    var seeds=(box.getAttribute('data-seeds')||'').split(',').filter(Boolean), cartCtx=seeds.length>0;
    var p=cartCtx ? Promise.resolve(seeds.slice(0,3)) : Promise.all(rv.slice(0,3).map(function(h){
      if(ids[h]) return ids[h];
      return fetch(root+'products/'+encodeURIComponent(h)+'.js').then(function(r){ return ok(r)?r.json():null; }).then(function(j){ return j&&j.id; }).catch(function(){ return null; });
    }));
    p.then(function(arr){
      arr=(arr||[]).filter(Boolean); if(!arr.length) return null;
      return Promise.all(arr.map(function(id){
        return fetch(root+'recommendations/products?product_id='+encodeURIComponent(id)+'&limit=10&intent=related&section_id=mw-foryou').then(function(r){ return ok(r)?r.text():''; }).catch(function(){ return ''; });
      }));
    }).then(function(htmls){
      if(!htmls) return;
      var seen={}, types={}, out=[], i, j, more=true;
      if(!cartCtx) rv.forEach(function(h){ seen[h]=1; });
      var lists=htmls.map(function(t){
        if(!t) return [];
        var d=new DOMParser().parseFromString(t,'text/html');
        return [].slice.call(d.querySelectorAll('[data-mwr-fy-src] > li'));
      });
      /* Tohum ürünlerden sırayla birer öneri al (çeşitlilik), aynı türden en fazla 4 */
      for(i=0; more&&out.length<12; i++){
        more=false;
        for(j=0;j<lists.length&&out.length<12;j++){
          var li=lists[j][i]; if(!li) continue; more=true;
          var h=li.getAttribute('data-h'), t=li.getAttribute('data-t')||'';
          if(!h||seen[h]||(types[t]||0)>=4) continue;
          seen[h]=1; types[t]=(types[t]||0)+1; out.push(li);
        }
      }
      if(out.length<4) return;
      var frag=document.createDocumentFragment();
      out.forEach(function(li){ frag.appendChild(document.importNode(li,true)); });
      list.appendChild(frag);
      var sub=box.querySelector('[data-mwr-fy-sub]');
      if(sub&&cartCtx) sub.textContent='Sepetindeki ürünlere göre seçtik';
      box.hidden=false;
      if(typeof window.initializeScrollAnimationTrigger==='function'){ try{ window.initializeScrollAnimationTrigger(box); }catch(e){} }
      nav();
    }).catch(function(){});
  }
  /* Masaüstü ok butonları */
  var bp=box.querySelector('[data-mwr-fy-d="-1"]'), bn=box.querySelector('[data-mwr-fy-d="1"]');
  function nav(){
    if(!bp||!bn) return;
    var max=list.scrollWidth-list.clientWidth-2;
    bp.disabled=list.scrollLeft<=2; bn.disabled=list.scrollLeft>=max;
  }
  box.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-mwr-fy-d]'); if(!b) return;
    list.scrollBy({left:(+b.getAttribute('data-mwr-fy-d'))*list.clientWidth*.9,behavior:'smooth'});
  });
  var tk=0;
  list.addEventListener('scroll',function(){ if(tk) return; tk=requestAnimationFrame(function(){ tk=0; nav(); }); },{passive:true});
  window.addEventListener('resize',nav);
  /* Raf ekrana yaklaşınca yükle */
  if(sen&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ if(es.some(function(x){ return x.isIntersecting; })){ io.disconnect(); go(); } },{rootMargin:'900px 0px'});
    io.observe(sen);
  } else setTimeout(go,1500);
})();
